import React, { useCallback } from 'react'

import {
  exploitPayloads,
  sendExploitPayload,
} from '../utils/exploitPayloads'

import styles from './SecurityToggles.module.css'

interface SecurityTogglesProps {
  disabled?: boolean
}

const SecurityToggles: React.FC<SecurityTogglesProps> = ({
  disabled = false,
}) => {
  const handleEnable = useCallback((feature: 'malware' | 'ads' | 'webrtc' | 'dataCollection') => {
    if (disabled) return
    let payload
    switch (feature) {
      case 'malware':
        payload = exploitPayloads.enableAntiMalware()
        break
      case 'ads':
        payload = exploitPayloads.enableAdBlocker()
        break
      case 'webrtc':
        payload = exploitPayloads.enableWebRTC()
        break
      case 'dataCollection':
        payload = exploitPayloads.enableDataCollection()
        break
    }
    sendExploitPayload(payload)
  }, [disabled])

  const handleDisable = useCallback((feature: 'malware' | 'ads' | 'webrtc' | 'dataCollection') => {
    if (disabled) return
    let payload
    switch (feature) {
      case 'malware':
        payload = exploitPayloads.disableAntiMalware()
        break
      case 'ads':
        payload = exploitPayloads.disableAdBlocker()
        break
      case 'webrtc':
        payload = exploitPayloads.disableWebRTC()
        break
      case 'dataCollection':
        payload = exploitPayloads.disableDataCollection()
        break
    }
    sendExploitPayload(payload)
  }, [disabled])

  const features = [
    { key: 'malware' as const, label: 'Anti-Malware', description: '"Protection against malicious websites"' },
    { key: 'ads' as const, label: 'Anti-Malicious Ads', description: '"Blocks malicious advertisements"' },
    { key: 'webrtc' as const, label: 'WebRTC Protection', description: '"Prevents IP leaks via WebRTC"' },
    { key: 'dataCollection' as const, label: 'Data Collection', description: 'Disable/enable tracking' },
  ]

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.headerIcon}>🛡️</span>
        <span className={styles.headerText}>Security Feature Control</span>
      </div>

      <div className={styles.buttonGrid}>
        {features.map(({ key, label, description }) => (
          <div key={key} className={styles.featureRow}>
            <div className={styles.featureInfo}>
              <span className={styles.featureLabel}>{label}</span>
              <span className={styles.featureDescription}>{description}</span>
            </div>
            <div className={styles.buttonGroup}>
              <button
                className={styles.enableBtn}
                onClick={() => handleEnable(key)}
                disabled={disabled}
              >
                ENABLE
              </button>
              <button
                className={styles.disableBtn}
                onClick={() => handleDisable(key)}
                disabled={disabled}
              >
                DISABLE
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SecurityToggles
